import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchers } from "../fetchers";
import { VaultKeyInsert, VaultKeyUpdate } from "../fetchers/vault-keys";

export const VAULT_KEYS_KEY = "vault_keys";

const useVaultKeyByUserId = (userId?: string | null) => {
  return useQuery({
    queryKey: [VAULT_KEYS_KEY, userId],
    queryFn: () => (userId ? fetchers.vaultKeys.fetchVaultKeyByUserId(userId) : undefined),
    enabled: !!userId,
  });
};

const useAddVaultKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (vaultKey: VaultKeyInsert) => fetchers.vaultKeys.addVaultKey(vaultKey),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: [VAULT_KEYS_KEY, data.user_id] });
    },
  });
};

const useUpdateVaultKey = (userId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (vaultKey: Partial<VaultKeyUpdate>) => fetchers.vaultKeys.updateVaultKey({ userId: userId!, vaultKey }),
    onSuccess: () => {
      if (userId) {
        queryClient.invalidateQueries({ queryKey: [VAULT_KEYS_KEY, userId] });
      }
    },
  });
};

const useDeleteVaultKey = (userId?: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => fetchers.vaultKeys.deleteVaultKey(userId!),
    onSuccess: () => {
      if (userId) {
        queryClient.invalidateQueries({ queryKey: [VAULT_KEYS_KEY, userId] });
      }
    },
  });
};

export const vaultKeysHooks = {
  useVaultKeyByUserId,
  useAddVaultKey,
  useUpdateVaultKey,
  useDeleteVaultKey,
};
